"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendUploadFilesEvent = void 0;
const constants_1 = require("modules/app/services/datahub/constants");
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
const helper_1 = require("modules/app/services/datahub/helper");
const sendUploadFilesEvent = () => {
    DatahubService_1.default.sendEvent({
        action: constants_1.EVENT_ACTIONS.INTERACT,
        event: (0, helper_1.buildInteractionEventData)({
            category: constants_1.EVENTS_CATEGORY.CONTENT.NAME,
            label: constants_1.EVENTS_LABELS.CONTENT.UPLOAD_FILES,
            url: '/modules',
            action: constants_1.EVENTS_INTERACTIONS.CLICK
        })
    });
};
exports.sendUploadFilesEvent = sendUploadFilesEvent;
